import { Cookie } from '@nuxt-common/util/app/utils/cookie';

const sessionTimeoutRedirectHandler = ({ errorCode } = {}) => {
  const redirectErrorCodes = ['45001', '45006', '45201'];
  if (errorCode && redirectErrorCodes.includes(errorCode.toString())) {
    const domain = Cookie.getHostName();
    Cookie.remove('SignedIn', null, {
      domain,
    });
    Cookie.set('SE', 1, 'SNSGCs', {
      domain,
    });
    Cookie.set('FORWARDPAGE_KEY', window.location, null, {
      domain,
    });
    window.location.href = '/account/signin-loyalty';
  }
};

export default sessionTimeoutRedirectHandler;
